module.exports = __webpack_public_path__ + "media/images/icons/illustration/one-day-offer-412e2020e07cc8fc6f2d3bf716776e72.svg";